<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-left">
        <div
          v-show="stateArrow"
          id="leftBox"
          class="leftBox"
          style="width: 206px"
        >
          <vue-draggable-resizable
            :min-width="160"
            @resizing="onResize"
            :max-width="400"
            :draggable="false"
            :handles="['mr']"
            :w="206"
            :parent="false"
          >
            <div class="carDisLeft">
              <div class="dirTop">
                <el-scrollbar>
                  <tree
                    :isSearch="isSearch"
                    @initFun="initQuery"
                    @nodeClick="nodeClick"
                  ></tree>
                </el-scrollbar>
              </div>
              <div class="dirBottom">
                <el-input
                  style="width: 96%"
                  class="inputStyle"
                  @keyup.enter.native="onkeyUp"
                  v-model="fenceName"
                  size="small"
                  :placeholder="$t('common.searchTip')"
                ></el-input>
                <i-table
                  :list="list"
                  :height="height"
                  ref="carTable"
                  :options="option"
                  :columns="columns"
                  :operates="operates"
                  @rowClick="rowClick"
                ></i-table>
                <IPagination ref="page" @PageFun="changeSize"></IPagination>
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
        <div class="leftCaret" @click="changeArrow">
          <i
            :class="stateArrow ? 'el-icon-caret-left' : 'el-icon-caret-right'"
          ></i>
        </div>
      </div>
      <div class="carDisRight">
        <div class="carBaidu">
          <div class="encFresh">
            <el-button
              v-if="btnShow"
              @click="createMap"
              type="primary"
              size="small"
              class="bmap-btn bmap-polygon"
              >{{$t('SafeManagement.form.addFence')}}</el-button
            >
            <el-button
              v-if="!btnShow"
              @click="PutData"
              type="primary"
              size="small"
              >{{$t('common.btn.confirm')}}</el-button
            >
            <el-button
              v-if="!btnShow"
              @click="cancle"
              type="primary"
              size="small"
              >{{$t('common.btn.cancel')}}</el-button
        >
          </div>
          <div
            v-loading="mapLoading"
            id="allmap"
            ref="allmap"
            style="width: 100%; height: 100%"
          ></div>
        </div>
      </div>
      <el-dialog
        :before-close="resetForm"
        width="80%"
        :title="title"
        v-if="dialogFormVisible"
        :visible.sync="dialogFormVisible"
        class="Dialong"
        :close-on-click-modal="false"
      >
        <span
          ><i-Car
            ref="transfer"
            @postParam="postParam"
            :carItem ="carItem"
            :id="id"
          ></i-Car
        ></span>
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            prop="fenceName"
            :label="$t('SafeManagement.fenceName')"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.fenceName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="centerLng"
            :label="$t('SafeManagement.centerLng')"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              size="small"
              v-model="form.centerLng"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="centerLat"
            :label="$t('SafeManagement.centerLat')"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              size="small"
              v-model="form.centerLat"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="radius"
            :label="$t('SafeManagement.radius')"
            :label-width="formLabelWidth"
          >
            <el-input
              disabled
              size="small"
              v-model="form.radius"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="level" :label="$t('SafeManagement.level')" :label-width="formLabelWidth">
            <el-input
              disabled
              size="small"
              v-model="form.level"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="resetForm">{{$t('common.btn.cancel')}}</el-button
                >
          <el-button
            :loading="btnSpin"
            size="small"
            type="primary"
            @click="submitForm('form')"
            >{{$t('common.btn.confirm')}}</el-button
                >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import CloudFence from "./CloudFence.js";
export default CloudFence;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
</style>
